import { forwardRef } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

const TableBody = /*#__PURE__*/forwardRef((props, ref) => jsx("tbody", {
  ref: ref,
  ...props
}));
TableBody.displayName = 'TableBody';

export { TableBody };
//# sourceMappingURL=TableBody.js.map
